import Vue from 'vue';
import { isString, isObject, isFunction } from 'lodash';
import VideoPlayerDialog from './VideoPlayerDialog';
const VideoPlayerDialogConstructor = Vue.extend(VideoPlayerDialog);

export function openVideoDialog(options) {
  let instance = null;
  let propsData = {};

  if (isString(options)) {
    propsData.url = options;
  } else if (isObject(options)) {
    propsData = { ...options };
  }

  if (!propsData.url) {
    return console.error('url is required');
  }

  propsData.onClose = (state) => {
    instance && instance.$el.remove();
    if (isFunction(options.onClose)) {
      options.onClose(state);
    }
  };

  instance = new VideoPlayerDialogConstructor({
    propsData
  });
  document.body.appendChild(instance.$mount().$el);
  instance.visible = true;
}
